<div class="container-fluid py-3 px-3 mb-4 left-menu-space" id="divMainContainer">
  <!--<div class="page-title-box d-sm-flex justify-content-between bd-highlight">
  </div>-->
  <div class="mb-3">
  <div class="row">
    <div class="col-md-7">
      <h4 class="mb-0 f-bold-dubai text-secondary pb-2">MOM Video Guide</h4>
      <div class="card rounded pt-2 h-100">
        <div class="pt-2 px-3 pb-3">
          <div class="embed-responsive embed-responsive-16by9">
            <video class="videoarea" controls #helpVideoPlayer id="helpVideoPlayer" [src]='videoPath' type="video/mp4">
              
             

            </video>
          </div>
          <div class="border-bottom py-3">
            <h5 class="mb-0">{{videoTitle}}</h5>
            <!--<small class="text-secondary">Apr 19, 2021</small>-->
          </div>
          <p class="border-bottom py-3 text-dark">
            {{videoDesc}}
          </p>
          <p class=" py-0">
            <a href="{{userguide}}" target="_blank" class="border-0 f-bold-dubai"><i class="fa fa-file-pdf-o fa-2x pr-2 text-danger"></i> Click to Download Guide</a>
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <h4 class="mb-0 f-bold-dubai text-secondary pb-2">MOM Related Video Guide</h4>
      <div class="card rounded pt-2 h-100">
        <div class="pt-2 px-3 pb-3 border-bottom-0">
          <ul class="nav nav-tabs bg-green-tab mb-2" id="myTab" role="tablist">

            <li class="nav-item">
              <a class="nav-link active pointer" id="user-tab" data-toggle="tab" href="#user" role="tab" aria-controls="user" aria-selected="false">User Guide</a>
            </li>
            <!--<li *ngIf="userRole == 1" class="nav-item">
              <a class="nav-link pointer" id="admin-tab" data-toggle="tab" href="#admin" role="tab" aria-controls="admin" aria-selected="true">Administration Guide</a>
            </li>-->

          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="user" role="tabpanel" aria-labelledby="user-tab">
              <div class="pt-2 px-0 border-bottom pointer" (click)="videoChange('login')">
                <div class="row ">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\help\MOM_PhaseI_Video_Thumb_Images\Login.png" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Login</h5>
                      <p class="text-secondary mb-2">Login functionality. </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-2 px-0 border-bottom pointer" (click)="videoChange('profile')">
                <div class="row ">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\help\MOM_PhaseI_Video_Thumb_Images\Login.png" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Profile</h5>
                      <p class="text-secondary mb-2">Profile page. </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pt-2 px-0 border-bottom pointer" (click)="videoChange('dash')">
                <div class="row ">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\help\MOM_PhaseI_Video_Thumb_Images\Login.png" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Dashboard</h5>
                      <p class="text-secondary mb-2">Dashboard items have been covered. </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pt-2 px-0 border-bottom pointer" (click)="videoChange('createMOM')">
                <div class="row ">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\help\MOM_PhaseI_Video_Thumb_Images\Login.png" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Create MOM</h5>
                      <p class="text-secondary mb-2">Create minutes of meeting. </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-2 px-0 border-bottom pointer" (click)="videoChange('review')">
                <div class="row ">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\help\MOM_PhaseI_Video_Thumb_Images\Login.png" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Review</h5>
                      <p class="text-secondary mb-2">Review Process. </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-2 px-0 border-bottom pointer" (click)="videoChange('approval')">
                <div class="row ">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\help\MOM_PhaseI_Video_Thumb_Images\Login.png" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Approval</h5>
                      <p class="text-secondary mb-2">Approval Process. </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-2 px-0 border-bottom pointer" (click)="videoChange('publish')">
                <div class="row ">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\help\MOM_PhaseI_Video_Thumb_Images\Login.png" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Publish and Download</h5>
                      <p class="text-secondary mb-2">Publish process and Pdf download. </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-2 px-0 border-bottom pointer" (click)="videoChange('copyFollow')">
                <div class="row ">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\help\MOM_PhaseI_Video_Thumb_Images\Login.png" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Copy and Follow up</h5>
                      <p class="text-secondary mb-2">Copy and Follow up process. </p>
                    </div>
                  </div>
                </div>
              </div>





              <div class="pt-2 px-0 border-bottom pointer" (click)="videoChange('attendance')">
                <div class="row ">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\help\MOM_PhaseI_Video_Thumb_Images\Login.png" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Digital attendance</h5>
                      <p class="text-secondary mb-2">Create new digital attendance. </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="admin" role="tabpanel" aria-labelledby="admin-tab">
              <div class="pt-2 px-0 border-bottom">
                <div class="row">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\v2\img\video-thumb1.jpg" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Admin</h5>
                      <div class=" position-absolute position-absolute position-top-0 position-right-15 hide-arrow-drop" ngbDropdown>
                        <!--<a class="nav-link p-0 " id="videoGuide" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg w-7"></i> </a>-->
                        <!--<ul ngbDropdownMenu aria-labelledby="videoGuide">
                          <li><a ngbDropdownItem > Save Video</a></li>
                        </ul>-->
                      </div>
                      <p class="text-secondary mb-2">Admin functionalities are listed in this video. </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-2 px-0 border-bottom">
                <div class="row">
                  <div class="col-4">
                    <img class="img-fluid" src="\assets\v2\img\video-thumb.jpg" />
                  </div>
                  <div class="col-8 px-0">
                    <div class=" position-relative">
                      <h5 class="">Admin Reports</h5>
                      <div class=" position-absolute position-absolute position-top-0 position-right-15 hide-arrow-drop" ngbDropdown>
                        <!--<a class="nav-link p-0 " id="videoGuide" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg w-7"></i> </a>-->
                        <!--<ul ngbDropdownMenu aria-labelledby="videoGuide">
                          <li><a ngbDropdownItem > Save Video</a></li>
                        </ul>-->
                      </div>
                      <p class="text-secondary mb-2">Admin Reports are covered. </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
